import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './AdminDashboard.css';

const SECTIONS = [
  {
    to: '/gestion-ecclesiale/events',
    icon: '📅',
    title: 'Événements',
    desc: 'Créer, modifier et supprimer les événements à venir et passés.',
    color: 'card--blue',
  },
  {
    to: '/gestion-ecclesiale/sermons',
    icon: '🎙️',
    title: 'Sermons',
    desc: 'Ajouter et gérer les sermons avec lien YouTube.',
    color: 'card--red',
  },
  {
    to: '/gestion-ecclesiale/ministries',
    icon: '🤝',
    title: 'Ministères',
    desc: 'Gérer les ministères, leurs responsables, horaires et lieux.',
    color: 'card--green',
  },
  {
    to: '/gestion-ecclesiale/announcements',
    icon: '📢',
    title: 'Annonces',
    desc: 'Publier, modifier et supprimer les annonces affichées sur la page d’accueil.',
    color: 'card--orange',
  },
  {
    to: '/gestion-ecclesiale/gallery',
    icon: '🖼️',
    title: 'Galerie',
    desc: 'Ajouter, modifier et supprimer les photos de la galerie.',
    color: 'card--purple',
  },
  {
    to: '/gestion-ecclesiale/leadership',
    icon: '👥',
    title: 'Équipe de Direction',
    desc: "Gérer les membres de l'équipe pastorale affichés sur la page À Propos.",
    color: 'card--gold',
  },
];

export default function AdminDashboard() {
  const navigate = useNavigate();

  function handleLogout() {
    localStorage.removeItem('adminToken');
    navigate('/gestion-ecclesiale/login');
  }

  return (
    <div className="dash-page">
      {/* Header */}
      <div className="dash-header">
        <div className="container">
          <div className="dash-header__inner">
            <div>
              <p className="dash-eyebrow">Panneau d'administration</p>
              <h1 className="dash-title">Première Église Chrétienne<br />De La Chambre Haute</h1>
            </div>
            <div className="dash-header__actions">
              <Link to="/" className="dash-back-btn">← Retour au site</Link>
              <button className="dash-logout-btn" onClick={handleLogout}>
                Déconnexion
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Cards */}
      <div className="container dash-body">
        <p className="dash-lead">
          Bienvenue dans l'espace d'administration. Choisissez une section à gérer.
        </p>

        <div className="dash-grid">
          {SECTIONS.map(({ to, icon, title, desc, color }) => (
            <Link key={to} to={to} className={`dash-card ${color}`}>
              <span className="dash-card__icon">{icon}</span>
              <h2 className="dash-card__title">{title}</h2>
              <p className="dash-card__desc">{desc}</p>
              <span className="dash-card__cta">Gérer →</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
